import {Component, Input } from "@angular/core";
import * as classNames from 'classnames';

export interface Chip {
  env: string;
  clientId: string;
  data:string[];
}
export interface ChipStyle {
  type: string;
  color: string;
}
export enum Type {'primary', 'secondary', 'tertiary'};
export enum Color {'costar', 'error'};
@Component({
  selector: "crem-chip",
  templateUrl: "./chip.component.html",
  styleUrls: ["./chip.component.scss"]
})
export class ChipComponent {
  withAnimationOptionsVisible: boolean;
  @Input() id: any;
  @Input() popoverContent: string[];
@Input() chipStyle: ChipStyle;
  constructor() {
    this.withAnimationOptionsVisible = false;
  }

 OnWithAnimationOptions() {
    this.withAnimationOptionsVisible = true;
  }
  OffWithAnimationOptions() {
    this.withAnimationOptionsVisible = false;
  }
}
